/* oxlint-disable @typescript-eslint/no-empty-function */
type Noop = () => void;

export const noop: Noop = () => {};
